<template>
  <Layout tituloPagina="Sistema | Cuenta | Cambiar de plan ISP">
    <div class="row">
      <div class="col-lg-3" v-show="estado_modulo == true">
        <div class="card">
          <div class="card-header bg-success justify-content-between d-flex align-items-center">
            <h4 class="card-title text-white">Plan ISP actual</h4>
            <div>
              <span class="badge bg-info bg-gradient">Activo</span>
            </div>
          </div>
          <div class="card-body" style="min-height: 509px;">
            <h1 class="text-center">
              <strong>Plan {{plan_isp_contratado.nombre}}</strong>
            </h1>
            <br>
            <table class="table">
              <tbody class="text-center">
                <tr>
                  <td style="width:50%;">Clientes</td>
                  <td>{{plan_isp_contratado.max_clientes != -1 ? 'hasta '+plan_isp_contratado.max_clientes : 'Ilimitado'}}</td>
                </tr>
                <tr>
                  <td>Contratos</td>
                  <td>{{plan_isp_contratado.max_contratos != -1 ? 'hasta '+plan_isp_contratado.max_contratos : 'Ilimitado'}}</td>
                </tr>
                <tr>
                  <td>CPEs</td>
                  <td>{{plan_isp_contratado.max_cpes != -1 ? 'hasta '+plan_isp_contratado.max_cpes : 'Ilimitado'}}</td>
                </tr>
                <tr>
                  <td>Routers de administración</td>
                  <td>{{plan_isp_contratado.max_routers != -1 ? 'hasta '+plan_isp_contratado.max_routers : 'Ilimitado'}}</td>
                </tr>
                <tr>
                  <td>Notificación de routers de administración caídos</td>
                  <td>{{plan_isp_contratado.notificacion_routers_caidos ? "SI": "NO"}}</td>
                </tr>
                <tr>
                  <td>Generación de facturas</td>
                  <td>{{plan_isp_contratado.generacion_facturas ? "SI": "NO"}}</td>
                </tr>
                <tr>
                  <td>Cortes de servicios</td>
                  <td>{{plan_isp_contratado.cortes_servicios ? "SI": "NO"}}</td>
                </tr>
                <tr>
                  <td>Mensaje de servicio suspendido</td>
                  <td>{{plan_isp_contratado.mensaje_servicio_suspendido ? "SI": "NO"}}</td>
                </tr>
                <tr>
                  <td>Reportes diarios</td>
                  <td>{{plan_isp_contratado.reportes_diarios ? "SI": "NO"}}</td>
                </tr>
                <tr>
                  <th>Notificación por correo electrónico</th>
                  <td>{{plan_isp_contratado.notificacion_por_email ? "SI": "NO"}}</td>
                </tr>
                <tr>
                  <td>Precio mensual</td>
                  <td>${{plan_isp_contratado.precio_mensual}} USD</td>
                </tr>
                <tr>
                  <td>Precio anual</td>
                  <td>
                    ${{plan_isp_contratado.precio_anual}} USD <br>
                    <strong>{{costoAnualPocentaje(plan_isp_contratado.precio_mensual, plan_isp_contratado.precio_anual)}}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="text-center">
              <p>
                <span class="h3">
                  <strong>Precio ${{plan_isp_contratado.precio_mensual}} USD</strong>
                </span><br>
                Costo mensual
              </p>
            </div>
            <br>
            <div class="text-center">
              <button
                class="btn w-200"
                :class="estado_modulo != true ? 'btn-success' : 'btn-danger'"
                @click="actDescEstModulo()"
              >
                <i class="mdi" :class="estado_modulo != true ? 'mdi-check-bold' : 'mdi-cancel'"></i>
                {{estado_modulo != true ? 'Activar modulo' : 'Desactivado modulo'}}
              </button>
            </div>
            <hr>
            <div class="text-center">
              <p>
                <strong>
                  Perido actual: {{formatoFecha(ultima_suscripcion.inicio)}} a {{formatoFecha(ultima_suscripcion.fin)}}
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div :class="estado_modulo == true ? 'col-lg-9' : 'col-lg-12'">
        <div class="row">
          <template v-for="plan_isp in planes_isp">
            <div v-if="true" :key="plan_isp.id" class="col-md-3">
              <div class="card">
                <div class="card-header bg-info justify-content-between d-flex align-items-center">
                  <h4 class="card-title text-white">{{plan_isp.nombre}}</h4>
                  <div>
                    <i class="mdi mdi-bookmark fa-lg text-white"></i>
                  </div>
                </div>
                <div class="card-body">
                  <h5 class="text-center">
                    <strong>Caracteristicas del plan</strong>
                  </h5>
                  <br>
                  <table class="table">
                    <tbody class="text-center">
                      <tr>
                        <td style="width:50%;">Gestión de clientes</td>
                        <td>{{plan_isp.max_clientes != -1 ? 'hasta '+plan_isp.max_clientes : 'Ilimitado'}}</td>
                      </tr>
                      <tr>
                        <td>Gestión de contratos</td>
                        <td>{{plan_isp.max_contratos != -1 ? 'hasta '+plan_isp.max_contratos : 'Ilimitado'}}</td>
                      </tr>
                      <tr>
                        <td>Gestión de CPEs</td>
                        <td>{{plan_isp.max_cpes != -1 ? 'hasta '+plan_isp.max_cpes : 'Ilimitado'}}</td>
                      </tr>
                      <tr>
                        <td>Gestión routers de administración</td>
                        <td>{{plan_isp.max_routers != -1 ? 'hasta '+plan_isp.max_routers : 'Ilimitado'}}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="text-center">
                    <p>
                      <span class="h4">
                        <strong>Precio ${{plan_isp.precio_mensual}} USD</strong>
                      </span><br>
                      Costo mensual
                    </p>
                  </div>
                  <br>
                  <div class="text-center">
                    <p>
                      <span class="h4">
                        <strong>Precio ${{plan_isp.precio_anual}} USD</strong>
                      </span><br>
                      {{costoAnualPocentaje(plan_isp.precio_mensual, plan_isp.precio_anual)}}
                    </p>
                  </div>
                  <div class="text-center">
                    <button
                      class="btn btn-outline-link text-success"
                      @click="caracteristicasIsp(plan_isp.id)">
                      Ver todas las caracteristicas
                    </button>
                  </div>
                  <br>
                  <router-link :to="{ name: 'actualizarPlanIsp', params:{ id_plan: plan_isp.id} }">
                    <div class="p-2 m-0 rounded text-center bg-soft-dark">
                      <span class="h4">
                        <strong>
                          {{estado_modulo ? 'Cambiar' : 'Activar'}} plan ISP
                        </strong>
                      </span>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div class="text-right pb-4" style="min-width: 220px;">
      <button class="btn btn-secondary" @click="$router.go(-1)">
        <i class="mdi mdi-chevron-left"></i>
        Atras
      </button>
    </div>
    <mdl-caracteristicas-isp ref="mdlCaracteristicasIsp"></mdl-caracteristicas-isp>
    <br>
  </Layout>
</template>

<script>
import Layout from '@/views/layouts/main'
import MdlCaracteristicasIsp from "./MdlCaracteristicasIsp.vue"
import CuentaSrv from "@/services/CuentaSrv.js"
import moment from 'moment'
export default {
  name: 'PlanesIsp',
  components: { Layout, MdlCaracteristicasIsp },
  data() {
    return {
      modulo: true,
      estado_modulo: false,

      plan_isp_contratado: {
        id:null,
        nombre: "",
        descripcion: "",
        max_clientes: 0,
        max_contratos: 0,
        max_cpes: 0,
        max_routers: 0,
        notificacion_routers_caidos: false,
        generacion_facturas: true,
        cortes_servicios: true,
        mensaje_servicio_suspendido: false,
        reportes_diarios: true,
        notificacion_por_email: false,
        precio_mensual: 0,
        precio_anual: 0,
      },
      planes_isp: [],

      ultima_suscripcion: {
        estado: 0,
        fin: "",
        id: null,
        id_cliente: null,
        id_empresa: null,
        id_plan_hotspot: null,
        id_plan_inventario: null,
        id_plan_isp: null,
        id_plan_vpn: null,
        inicio: "",
        renovar: 0,
        tipo_suscripcion: 0
      }
    }
  },

  created: function() {
    var self = this

    self.cargarEstado()
    self.refrescarPlanesIsp()
  },

  methods: {
    actDescEstModulo: function() {
      var self = this

      if(self.estado_modulo != 1) {
        CuentaSrv.activarModulo('isp').then(response => {
          iu.msg.success('Modulo ISP activado correctamente')
          self.cargarEstado()
        }).catch(error => {
          let mensaje
          try {
            mensaje = error.response.data.message
          } catch (e) {
            mensaje = 'No se pudo activar el modulo isp'
          }
          iu.msg.error(mensaje)
          console.log(error)
        })
      } else {
        CuentaSrv.desactivarModulo('isp').then(response => {
          iu.msg.success('Modulo ISP desactivado correctamente')
          self.cargarEstado()
        }).catch(error => {
          let mensaje
          try {
            mensaje = error.response.data.message
          } catch (e) {
            mensaje = 'No se pudo desactivar el modulo isp'
          }
          iu.msg.error(mensaje)
          console.log(error)
        })
      }
    },
    
    caracteristicasIsp: function(idPlan) {
      this.$refs.mdlCaracteristicasIsp.mostrar(idPlan, "planes", this.estado_modulo)
    },

    cargarEstado: function() {
      var self = this

      CuentaSrv.estadoModulo('isp').then(response => {
        self.estado_modulo = response.data

        if(self.estado_modulo == true) self.cargarPlanContratado()
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cargar cuenta'
        }
        iu.msg.error(mensaje)
        console.log(error)
      })
    },

    cargarPlanContratado: function (){
      var self = this

      CuentaSrv.moduloPlanContratadoJSON('isp').then(response => {
        self.plan_isp_contratado = response.data

        self.suscripcion()
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cargar cuenta'
        }
        iu.msg.error(mensaje)
        console.log(error)
      })
    },

    costoAnualPocentaje: function(precio_mensual, precio_anual){
      if(precio_anual < 0) return ''

      let total = precio_mensual * 12
      let porcentaje = ((total - precio_anual) * 100) / total

      if(porcentaje < 0) return ''

      return `Costo anual (incluye ${parseInt(porcentaje)}% de descuento)`
    },

    formatoFecha(mt, formato = 'DD/MM/YYYY') {
      return moment(mt).locale('es-mx').format(formato)
    },

    refrescarPlanesIsp: function() {
      var self = this

      CuentaSrv.moduloPlanesDisponiblesJSON('isp').then(response => {
        self.planes_isp = response.data
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'no se puedo cargar los planes ISP disponibles'
        }
        iu.msg.error(mensaje)
        console.log(error)
      })
    },

    suscripcion() {
      var self = this

      CuentaSrv.suscripcionJSON().then(response => {
        self.ultima_suscripcion = response.data
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cargar cuenta'
        }
        iu.msg.error(mensaje)
        console.log(error)
      })
    }
  },
}
</script>

<style scoped>

</style>